import { zodResolver } from '@hookform/resolvers/zod'
import { FormProvider, useForm } from 'react-hook-form'

import type { CreateListFormValues } from '@/modules/tiktok-research/videos/ui/create-list-form/validations.ts'
import {
  defaultList,
  listCreationFormSchema,
} from '@/modules/tiktok-research/videos/ui/create-list-form/validations.ts'

import { CreateListFormFields } from './CreateListFormFields.tsx'

interface Props {
  onSubmit: (values: CreateListFormValues) => Promise<void>
  formId: string
  defaultValues?: CreateListFormValues
}

export const CreateListForm = ({
  onSubmit,
  formId,
  defaultValues = defaultList,
}: Props) => {
  const form = useForm<CreateListFormValues>({
    resolver: zodResolver(listCreationFormSchema),
    defaultValues,
  })

  const handleSubmit = form.handleSubmit((values) => {
    onSubmit(values).then(() => {
      form.reset()
    })
  })

  return (
    <form
      className="space-y-6"
      onSubmit={handleSubmit}
      id={formId}
    >
      <FormProvider {...form}>
        <CreateListFormFields />
      </FormProvider>
    </form>
  )
}
